/**
 * The Station health page's calls (docs/specs/cloud/station-health.md; 20261027002100_station_health.sql): the
 * organisation's TA Live stations, health and connection (`my_station_health`, read through the staff policies), a
 * manager's reset of the connection and a station's offline alerts. What a person may do is decided by the database.
 */
import type { SupabaseClient } from '@supabase/supabase-js';
import { readStationHealth, type StationHealthAnswer } from '@teslyn/domain';

const fail = (e: { message: string } | null): void => {
  if (e) throw new Error(e.message);
};

export async function loadStationHealth(sb: SupabaseClient, tenantId: string): Promise<StationHealthAnswer> {
  const { data, error } = await sb.rpc('my_station_health', { p_tenant: tenantId });
  fail(error);
  return readStationHealth(data);
}

/** Clear the unanswered count and the pause; the next run (within 5 minutes) checks the stations. */
export async function resetConnector(sb: SupabaseClient, tenantId: string): Promise<boolean> {
  const { data, error } = await sb.rpc('station_connector_reset', { p_tenant: tenantId });
  fail(error);
  return data === true;
}

/** A tenant admin sets when a station counts as online (decision 59: 15 minutes by default). */
export async function setOnlineMinutes(sb: SupabaseClient, tenantId: string, minutes: number): Promise<void> {
  const { error } = await sb.rpc('station_set_online_minutes', { p_tenant: tenantId, p_minutes: minutes });
  fail(error);
}

export async function setOfflineAlerts(sb: SupabaseClient, stationId: string, on: boolean): Promise<void> {
  const { error } = await sb.rpc('station_set_offline_alerts', { p_station: stationId, p_on: on });
  fail(error);
}
